import * as React from 'react';
import {Grid} from "@material-ui/core";
import {ChangeEvent} from "react";
import {Defaults} from "../../defaults/Defaults";
import {TextValidator} from 'react-material-ui-form-validator';
import { traducirLabel } from '../../blocks/traductor';

interface Props {
    label: string
    value: string | number
    name: string
    isEmail?: boolean
    onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

const InputText = ({label, value, name, isEmail = false, onChange}: Props) => {
    const validators: string[] = ['required'];
    const errorMessages: string[] = [traducirLabel(126)];

    if(isEmail){
        validators.push('isEmail');
        errorMessages.push(traducirLabel(55));
    }

    return (<>
        <Grid item xs={12} sm={6} md={4}>
            <TextValidator
                label={label}
                value={value}
                name={name}
                onChange={onChange}
                variant="filled"
                fullWidth
                validators={validators}
                errorMessages={errorMessages}
            />
        </Grid>
    </>)
};

export default InputText;
